module.exports = __webpack_public_path__ + "img/cliente05.fb1c35a7.jpg";